var map = {
	"./Alok.png": "./src/images/members/Alok.png",
	"./Avignya.jpg": "./src/images/members/Avignya.jpg",
	"./Avinash.jpg": "./src/images/members/Avinash.jpg",
	"./Balram.png": "./src/images/members/Balram.png",
	"./Bani.png": "./src/images/members/Bani.png",
	"./Bipin.jpg": "./src/images/members/Bipin.jpg",
	"./Biraj.jpg": "./src/images/members/Biraj.jpg",
	"./Dev.png": "./src/images/members/Dev.png",
	"./Dhiraj.jpg": "./src/images/members/Dhiraj.jpg",
	"./Ishwor.jpg": "./src/images/members/Ishwor.jpg",
	"./Jatin.jpg": "./src/images/members/Jatin.jpg",
	"./Jay.jpeg": "./src/images/members/Jay.jpeg",
	"./Jivan.jpg": "./src/images/members/Jivan.jpg",
	"./Kashmir.jpg": "./src/images/members/Kashmir.jpg",
	"./Muhammad.jpg": "./src/images/members/Muhammad.jpg",
	"./Nirika.jpg": "./src/images/members/Nirika.jpg",
	"./Pankaj.jpg": "./src/images/members/Pankaj.jpg",
	"./Pooja.jpg": "./src/images/members/Pooja.jpg",
	"./Prabesh.jpg": "./src/images/members/Prabesh.jpg",
	"./Prakash.jpg": "./src/images/members/Prakash.jpg",
	"./Prince.jpg": "./src/images/members/Prince.jpg",
	"./Rakhi.jpg": "./src/images/members/Rakhi.jpg",
	"./Ruby.jpg": "./src/images/members/Ruby.jpg",
	"./Samiksha.jpg": "./src/images/members/Samiksha.jpg",
	"./Sandesh.jpg": "./src/images/members/Sandesh.jpg",
	"./Sandip.jpg": "./src/images/members/Sandip.jpg",
	"./Santosh.png": "./src/images/members/Santosh.png",
	"./Shikshit.jpg": "./src/images/members/Shikshit.jpg",
	"./Shivam.jpg": "./src/images/members/Shivam.jpg",
	"./Shova.jpg": "./src/images/members/Shova.jpg",
	"./Shreeichchha.jpg": "./src/images/members/Shreeichchha.jpg",
	"./Shreya.jpg": "./src/images/members/Shreya.jpg",
	"./Simonee.jpeg": "./src/images/members/Simonee.jpeg",
	"./Subash.jpeg": "./src/images/members/Subash.jpeg",
	"./Subigya.jpg": "./src/images/members/Subigya.jpg",
	"./Sujal.jpg": "./src/images/members/Sujal.jpg",
	"./Yugal.png": "./src/images/members/Yugal.png",
	"./bishwa.jpg": "./src/images/members/bishwa.jpg",
	"./dev1.png": "./src/images/members/dev1.png",
	"./dipu.jpg": "./src/images/members/dipu.jpg",
	"./khemraj.jpg": "./src/images/members/khemraj.jpg",
	"./rajendra.jpg": "./src/images/members/rajendra.jpg",
	"./rewan.jpg": "./src/images/members/rewan.jpg",
	"./shirshak.jpg": "./src/images/members/shirshak.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/members sync \\.(png%7Cjpe?g%7Csvg)$";